import axios from 'axios';
import { getOnlyToken } from './commonFunctions';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// console.log("BASE_URL", BASE_URL);

const apiClient = axios.create({
    baseURL: BASE_URL,
    withCredentials: true, // ✅ Required for sending & receiving cookies and 🔐 Required for cookie-based refresh
});

// Add a request interceptor to set the Authorization header dynamically
apiClient.interceptors.request.use((config) => {
    const token = getOnlyToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    // Dynamically set 'Content-Type' header for FormData
    if (config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data';
    } else {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
// // Response interceptor: auto-refresh token on 401
// apiClient.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;

//         // Token expired and not already retried
//         if (
//             error.response?.status === 401 &&
//             !originalRequest._retry &&
//             !originalRequest.url.includes("/token/refresh")
//         ) {
//             originalRequest._retry = true;

//             try {
//                 // Make request to refresh endpoint — assumes refresh token is in cookie
//                 const { data } = await axios.post(
//                     `${BASE_URL}/auth/token/refresh/`,
//                     {},
//                     {
//                         withCredentials: true, // Send the cookie
//                     }
//                 );

//                 const newAccessToken = data?.access;
//                 if (newAccessToken) {
//                     // setToken(newAccessToken); // save to localStorage or context
//                     // Retry original request with new token
//                     originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
//                     return apiClient(originalRequest);
//                 } else {
//                     throw new Error("No new access token received");
//                 }
//             } catch (refreshError) {
//                 console.error("Refresh token failed", refreshError);
//                 // clearToken(); // clear localStorage or any saved state
//                 window.location.href = "/login"; // force login
//                 return Promise.reject(refreshError);
//             }
//         }

//         return Promise.reject(error);
//     }
// );

// Define common API methods
export const _get = (url, config = {}) => {
    return apiClient.get(url, config);
};

export const _delete = (url, config = {}) => {
    return apiClient.delete(url, config);
};

export const _put = (url, data = {}, config = {}) => {
    return apiClient.put(url, data, config);
};

export const _post = (url, data = {}, config = {}) => {
    return apiClient.post(url, data, config);
};

export const _patch = (url, data = {}, config = {}) => {
    return apiClient.patch(url, data, config);
};

export const signupCustomer = (api_input) => {
    return _post('api/auth/register/', api_input);
}

export const verifyCustomerEmail = (api_input) => {
    return _post('user/verify-email/', api_input);
}
export const loginCustomer = (api_input) => {
    return _post('api/auth/login/', api_input);
}
export const forgotPassword = (api_input) => {
    return _post('api/auth/forgot-password/', api_input);
}
export const resendOtp = (api_input) => {
    return _post('api/auth/resend-2fa/', api_input);
}
export const updateUserPassword = (api_input) => {
    return _post('api/auth/reset-password/', api_input);
}
export const captchrefresh = async () => {
    return await _get('api/auth/generate-captcha/');
};

export const otpVerification = (api_input) => {
    return _post('api/auth/verify-2fa/', api_input);
}


//Plans
export const getPlans = () => {
    return _get('api/auth/plans/');
}

//Profile
export const getProfileDetails = () => {
    return _get('api/auth/profile/');
}
export const updateProfile = (api_input) => {
    return _put('api/auth/profile/', api_input);
}
///////////// tickets ////////////////

export const fetchTicketListData = (params) => {
    const response = _post(`api/support/tickets_list`, params);
    return response;
}

export const fetchTicketDetailsData = (params) => {
    const response = _get(`api/support/ticket_details/${params?.ticket_number}/`);
    return response;
}

export const addTicketReply = (ticket_number, params) => {
    const response = _put(`api/support/ticket_update/${ticket_number}/update/`, params);
    return response;
};

export const fetchParentTickect = (api_input) => {
    return _get('api/support/get_ticket_parent_category', api_input);
};

export const fetchParentCreateTickect = (parcategory, api_input) => {
    return _get(`api/support/get_ticket_category?parent_category=${parcategory}`, api_input);
};

export const fetchCreateTicket = (api_input) => {
    return _post(`api/support/create_ticket`, api_input);
};


export const fetchCountryList = (api_input) => {
    const response = _get(`api/auth/countries`, api_input);
    return response;
};

export const fetchStateList = (id) => {
    const response = _get(`api/auth/states/?country_id=${id}`);
    return response;
};


export const otpRegistration = (api_input) => {
    return _post('api/auth/verify-signup-otp/', api_input);
}



export const resendOtpRegistration = (api_input) => {
    return _post('api/auth/resend-signup-otp/', api_input);
};

// 

export const getFolderList = (page_size = 10, page_number = 1, search = "") => {
    const params = new URLSearchParams();
    params.append('page_size', page_size);
    params.append('page_number', page_number);
    if (search.trim()) {
        params.append('search', search);
    }
    return _get(`api/agents/folder/create/?${params.toString()}`);
}

export const getFolders = (page_size = 10, page_number = 1, search = "") => {
    const params = new URLSearchParams();
    if (search.trim()) {
        params.append('search', search);
    }
    return _get(`api/agents/folder/create/?${params.toString()}`);
}

export const SaveFolderName = (api_input) => {
    return _post('api/agents/folder/create/', api_input);
}
export const UpdateFolderName = (data) => {
    const response = _put(`api/agents/folder/update/`, data);
    return response;
};

export const DeleteFolderName = (id) => {

    return apiClient.request({
        url: "api/agents/folder/delete/",
        method: "DELETE",
        data: { folder_id: id }
    });

}

export const DeleteAgentByID = (id) => {

    return apiClient.request({
        url: `api/admin/agent/delete/`,
        method: "DELETE",
        data: { agent_id: id }
    });

}
export const CreateAgentBasic = (api_input) => {
    return _put('api/admin/agent/update/', api_input);
}
export const UpdateAgentBasic = (api_input) => {
    return _put('api/admin/agent/update/', api_input);
}




export const LLMandVoiceConfiguration = (api_input) => {
    return _put(`api/agents/llm-voice-config/update/?agent_id=${api_input.agent_id}`, api_input);
}

export const LLMandVoiceConfigurationUpdate = (api_input) => {
    return _put(`api/agents/llm-voice-config/update/?agent_id=${api_input.agent_id}`, api_input);
}


export const TranscriberProviderAPI = (api_input) => {
    return _put(`api/agents/transcriber/?agent_id=${api_input.agent_id}`, api_input);
}

export const TranscriberProviderUpdateAPI = (api_input) => {
    return _put(`api/agents/transcriber/?agent_id=${api_input.agent_id}`, api_input);
}


export const PredefinedFunctionsAPI = (api_input) => {
    return _put(`api/agents/predefined-functions/?agent_id=${api_input.agent_id}`, api_input);
}

export const PredefinedFunctionsUpdateAPI = (api_input) => {
    return _put(`api/agents/predefined-functions/?agent_id=${api_input.agent_id}`, api_input);
}


export const AgentSummaryAPI = (api_input) => {
    return _put(`api/agents/summary-configuration/?agent_id=${api_input.agent_id}`, api_input);
}

export const AgentSummaryUpdateAPI = (api_input) => {
    return _put(`api/agents/summary-configuration/?agent_id=${api_input.agent_id}`, api_input);
}


export const CallPrivacyAPI = (api_input) => {
    return _put(`api/agents/call-privacy/?agent_id=${api_input.agent_id}`, api_input);
}

export const CallPrivacyUpdateAPI = (api_input) => {
    return _put(`api/agents/call-privacy/?agent_id=${api_input.agent_id}`, api_input);
}


export const getAIAgentsbyFolder = (search = "") => {
    return _get(`api/agents/folder-wise/agents/?search=${search}`);
};



export const getAIAgentsbyID = (id) => {
    return _get(`api/agents/detail/?agent_id=${id}`);
}

export const getAIAgentsbyIDLLMData = (id) => {
    return _get(`api/agents/llm-voice-config/?agent_id=${id}`);
}

export const getAIAgentsbyIDTranscriber = (id) => {
    return _get(`api/agents/transcriber/?agent_id=${id}`);
}

export const getAIAgentsbyIDSummary = (id) => {
    return _get(`api/agents/summary-configuration/?agent_id=${id}`);
}
export const getAIAgentsbyIDPredefinedFunctions = (id) => {
    return _get(`api/agents/predefined-functions/?agent_id=${id}`);
}

export const getAIAgentsbyIDCallPrivacy = (id) => {
    return _get(`api/agents/call-privacy/?agent_id=${id}`);
}

export const getCallingoActivityLog = (pagesize, page) => {
    return _get(`api/auth/activity-log/?page_number=${page}&page_size=${pagesize}`);
}

export const getPaymentHistoryList = (api_input) => {
    return _post(`api/billing/payment-history/`, api_input);

}
export const getCallLogFormAPIList = (url) => {
    return _get(`${url}`);

}

export const getLLMConfigurationsList = () => {
    return _get(`api/agents/list-llm-providers/`);
}

export const SaveLLMConfig = (api_input) => {
    return _post('api/agents/llm-config/', api_input);
}
export const UpdateLLMConfig = (data) => {
    const response = _put(`api/agents/llm-config/${data.folder_id}/`, data);
    return response;
};


export const DeleteLLMConfig = (id) => {
    const response = _delete(`api/agents/llm-config/${id}/`);
    return response;
};


export const getVoiceConfigurationsList = () => {
    return _get(`api/agents/list-tts-providers/`);
}

export const getVoiceModelList = () => {
    return _get(`api/agents/get-tts-voices/`);
}

export const SaveVoiceConfigs = (api_input) => {
    return _post('api/agents/voice-config/', api_input);
}
export const UpdateVoiceConfigs = (data) => {
    const response = _put(`api/agents/voice-config/${data.folder_id}/`, data);
    return response;
};


export const DeleteVoiceConfigs = (id) => {
    const response = _delete(`api/agents/voice-config/${id}/`);
    return response;
};


export const getTranscriberConfigs = () => {
    return _get(`api/agents/list-stt-providers/`);
}

export const getTranscriberLanguage = () => {
    return _get(`api/agents/get-speech-to-text/`);
}

export const SaveTranscriberConfigs = (api_input) => {
    return _post('api/agents/transcriber-config/', api_input);
}
export const UpdateTranscriberConfigs = (data) => {
    const response = _put(`api/agents/transcriber-config/${data.folder_id}/`, data);
    return response;
};


export const DeleteTranscriberConfigs = (id) => {
    const response = _delete(`api/agents/transcriber-config/${id}/`);
    return response;
};

export const SendBulkCallFiles = (api_input) => {
    return _post('api/agents/excel-upload/', api_input, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

// ─── Calling V2 ───────────────────────────────────────────────────────────
export const CallingV2 = {
    listProviders: () => _get('api/calling-v2/admin/providers/'),
    listTemplates: (params) => _get('api/calling-v2/admin/templates/', { params }),
    getTemplate: (id) => _get(`api/calling-v2/admin/templates/${id}/`),
    createTemplate: (body) => _post('api/calling-v2/admin/templates/', body),
    updateTemplate: (id, body) => _put(`api/calling-v2/admin/templates/${id}/`, body),
    deleteTemplate: (id) => _delete(`api/calling-v2/admin/templates/${id}/`),

    listVoices: (params) => _get('api/calling-v2/admin/voices/', { params }),
    getVoice: (id) => _get(`api/calling-v2/admin/voices/${id}/`),
    createVoice: (body) => _post('api/calling-v2/admin/voices/', body),
    updateVoice: (id, body) => _put(`api/calling-v2/admin/voices/${id}/`, body),
    deleteVoice: (id) => _delete(`api/calling-v2/admin/voices/${id}/`),

    // KB templates (owner_org=NULL)
    listKBTemplates: () => _get('api/calling-v2/admin/knowledge-templates/'),
    getKBTemplate: (id) => _get(`api/calling-v2/admin/knowledge-templates/${id}/`),
    createKBTemplate: (body) => _post('api/calling-v2/admin/knowledge-templates/', body),
    updateKBTemplate: (id, body) => _put(`api/calling-v2/admin/knowledge-templates/${id}/`, body),
    deleteKBTemplate: (id) => _delete(`api/calling-v2/admin/knowledge-templates/${id}/`),
    listKBTemplateDocs: (id) => _get(`api/calling-v2/admin/knowledge-templates/${id}/documents/`),
    uploadKBTemplateDoc: (id, formData) => _post(`api/calling-v2/admin/knowledge-templates/${id}/documents/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    deleteKBTemplateDoc: (id, docId) => _delete(`api/calling-v2/admin/knowledge-templates/${id}/documents/${docId}/`),

    // IVR templates
    listIVRTemplates: () => _get('api/calling-v2/admin/ivr-templates/'),
    getIVRTemplate: (id) => _get(`api/calling-v2/admin/ivr-templates/${id}/`),
    createIVRTemplate: (body) => _post('api/calling-v2/admin/ivr-templates/', body),
    updateIVRTemplate: (id, body) => _put(`api/calling-v2/admin/ivr-templates/${id}/`, body),
    deleteIVRTemplate: (id) => _delete(`api/calling-v2/admin/ivr-templates/${id}/`),

    // Tool catalog (admin)
    listTools: (params) => _get('api/calling-v2/admin/tools/', { params }),
    getTool: (id) => _get(`api/calling-v2/admin/tools/${id}/`),
    createTool: (body) => _post('api/calling-v2/admin/tools/', body),
    updateTool: (id, body) => _put(`api/calling-v2/admin/tools/${id}/`, body),
    deleteTool: (id) => _delete(`api/calling-v2/admin/tools/${id}/`),
    testTool: (id, payload) => _post(`api/calling-v2/admin/tools/${id}/test/`, { payload }),

    // Hold music (admin)
    listHoldMusic: () => _get('api/calling-v2/admin/hold-music/'),
    uploadHoldMusic: (formData) => _post('api/calling-v2/admin/hold-music/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    updateHoldMusic: (id, body) => _put(`api/calling-v2/admin/hold-music/${id}/`, body),
    deleteHoldMusic: (id) => _delete(`api/calling-v2/admin/hold-music/${id}/`),

    // Call summary config (global admin singleton — OpenAI-backed post-call
    // summarizer). GET/PUT the config; POST /test/ runs a dry-run summary
    // on a paste-in transcript against the CURRENT saved config so admins
    // can iterate on the system prompt before flipping the feature on.
    getSummaryConfig: () => _get('api/calling-v2/admin/summary-config/'),
    updateSummaryConfig: (body) => _put('api/calling-v2/admin/summary-config/', body),
    testSummaryConfig: (transcript) => _post('api/calling-v2/admin/summary-config/test/', { transcript }),
};

// ─── Coupons (admin CRUD) ──────────────────────────────────────────────────
// Rebuilt from scratch after migration 0037 dropped the legacy skeleton.
// Discount applies to the first-charge only; ARB recurring stays at plan
// price. See apps/billing/services.apply_coupon_to_charge for the runtime
// eligibility gates.
export const AdminCoupons = {
    list: (params) => _get('api/admin/coupons/', { params }),
    get: (id) => _get(`api/admin/coupons/${id}/`),
    create: (body) => _post('api/admin/coupons/', body),
    // Full-form edit (dialog submit) — sends every field.
    update: (id, body) => _put(`api/admin/coupons/${id}/`, body),
    // Partial edit (toggle Active/Inactive, single-field tweaks) — routes
    // through PATCH so the serializer's required-field checks stay off
    // and the row-level "Pause" button doesn't fail with "code required".
    patch: (id, body) => _patch(`api/admin/coupons/${id}/`, body),
    // Soft-delete on the server (flips is_active=false) so redemption FKs
    // stay intact for audit.
    remove: (id) => _delete(`api/admin/coupons/${id}/`),
    listRedemptions: (id) => _get(`api/admin/coupons/${id}/redemptions/`),
    // Used by the "Eligible orgs" multi-select picker on the CouponDialog.
    // Matches org name / member login email.
    searchOrganizations: (q, limit = 20) =>
        _get('api/admin/organizations/search/', { params: { q, limit } }),
};

// ─── Customer Detail — org-scoped admin surface ───────────────────────────
// Powers the /customers/customerslist/:orgId tabbed detail page. Mostly
// read-only; the one write is assigning a phone number, which is an admin
// action by definition — the customer cannot buy a ported number themselves.
export const AdminOrganizations = {
    detail: (orgId) => _get(`api/admin/organizations/${orgId}/`),
    paymentMethods: (orgId) =>
        _get(`api/admin/organizations/${orgId}/payment-methods/`),
    events: (orgId, params = {}) =>
        _get(`api/admin/organizations/${orgId}/events/`, { params }),
    couponRedemptions: (orgId, params = {}) =>
        _get(`api/admin/organizations/${orgId}/coupon-redemptions/`, { params }),
    trials: (orgId) =>
        _get(`api/admin/organizations/${orgId}/trials/`),
    phoneNumbers: (orgId) =>
        _get(`api/admin/organizations/${orgId}/phone-numbers/`),
    // body: { phone_number_e164, line_type, monthly_price, source,
    //         note?, skip_vendor_check? }
    // monthly_price 0 => free, no Authorize.net subscription, no card needed.
    assignPhoneNumber: (orgId, body) =>
        _post(`api/admin/organizations/${orgId}/phone-numbers/assign/`, body),
};

// ─── Assigned phone numbers ───────────────────────────────────────────────
// Unassign stops the billing and the routing but keeps the number on the
// customer's account. It never releases it to the carrier: a ported number
// belongs to the customer and giving one up is a carrier port-out.
export const AdminPhoneNumbers = {
    unassign: (numberId, reason) => _post(
        `api/admin/phone-numbers/${numberId}/unassign/`, { reason },
    ),
};

// ─── Free-trial policy (admin singleton) ──────────────────────────────────
// Master enable + per-category allowances read by the marketplace subscribe
// modal (via the public /api/free-trial/ endpoint). All fields are safe to
// write; no masked secrets here (unlike Branding's smtp_password).
export const AdminFreeTrials = {
    get: () => _get('api/admin/free-trial/'),
    update: (body) => _put('api/admin/free-trial/', body),
};

// ─── Terms & Conditions (admin singleton) ────────────────────────────────
// One body of text + a version. PUT bumps the version only when the content
// actually changes (whitespace-normalized), which forces every customer to
// re-accept on next login. A save with no edits is a no-op and does not
// re-prompt anyone.
export const AdminTerms = {
    get: () => _get('api/admin/terms/'),
    update: (content) => _put('api/admin/terms/', { content }),
};

// ─── Help Center (admin video library) ───────────────────────────────────
// Videos are uploaded as multipart; the request interceptor above already
// switches Content-Type when the body is FormData, so just pass the
// FormData through. `onProgress` is wired because a 200 MB upload
// otherwise looks like a frozen button — nothing else in this app uses
// onUploadProgress today.
const withProgress = (onProgress) => (onProgress
    ? {
        onUploadProgress: (e) => {
            if (!e.total) return;
            onProgress(Math.round((e.loaded * 100) / e.total));
        },
    }
    : {});

export const AdminHelpCenter = {
    listVideos: (params = {}) => _get('api/admin/help-center/videos/', { params }),
    getVideo: (id) => _get(`api/admin/help-center/videos/${id}/`),
    createVideo: (formData, onProgress) => _post(
        'api/admin/help-center/videos/', formData, withProgress(onProgress),
    ),
    updateVideo: (id, formData, onProgress) => _put(
        `api/admin/help-center/videos/${id}/`, formData, withProgress(onProgress),
    ),
    deleteVideo: (id) => _delete(`api/admin/help-center/videos/${id}/`),

    listCategories: (params = {}) => _get('api/admin/help-center/categories/', { params }),
    createCategory: (body) => _post('api/admin/help-center/categories/', body),
    updateCategory: (id, body) => _put(`api/admin/help-center/categories/${id}/`, body),
    deleteCategory: (id) => _delete(`api/admin/help-center/categories/${id}/`),
};

// ─── Number porting requests (admin review queue) ─────────────────────────
// Customers submit these from the portal with the details the losing carrier
// needs plus a signed Letter of Authorization. Approving is the decision;
// completing records that the carrier has actually finished the port, which
// is the part customers chase. Approving does NOT create a phone number —
// handing the customer the number is a separate assign action, so that it
// works just as well for a number that never had a request.
export const AdminPortRequests = {
    list: (params = {}) => _get('api/admin/port-requests/', { params }),
    get: (id) => _get(`api/admin/port-requests/${id}/`),
    approve: (id, adminNotes) => _post(
        `api/admin/port-requests/${id}/approve/`, { admin_notes: adminNotes || '' },
    ),
    reject: (id, reason) => _post(
        `api/admin/port-requests/${id}/reject/`, { reason },
    ),
    complete: (id, adminNotes) => _post(
        `api/admin/port-requests/${id}/complete/`, { admin_notes: adminNotes || '' },
    ),
};

export const AdminPaymentAttempts = {
    list: (params = {}) => _get('api/admin/payment-attempts/', { params }),
    get: (id) => _get(`api/admin/payment-attempts/${id}/`),
};

// ─── Phone-number KYC verification (admin review queue) ────────────────────
// Customers upload EIN + Incorporation + Address-proof from the customer
// portal (via /api/billing/phone-verification/); this queue is where the
// compliance reviewer approves or rejects. Approval unlocks the V2
// Buy-Numbers page for that org. Rejection with a reason lets the customer
// re-upload after fixing the flagged document.
// ─── Deployment-wide policy knobs ─────────────────────────────────────────
// The PaymentBehaviorSettings singleton. Named for the AmEx surcharge it
// started with, but it also carries the switch that decides whether KYC is
// required before an organisation can buy a phone number — the toggle for
// which lives on the Phone Verifications page, since that is where an admin
// looks for it rather than here.
export const AdminPaymentBehavior = {
    get: () => _get('api/admin/payment-behavior/'),
    patch: (body) => _patch('api/admin/payment-behavior/', body),
};

export const AdminPhoneVerifications = {
    list: (params = {}) => _get('api/admin/phone-verifications/', { params }),
    get: (orgId) => _get(`api/admin/phone-verifications/${orgId}/`),
    approve: (orgId) => _post(`api/admin/phone-verifications/${orgId}/approve/`, {}),
    reject: (orgId, reason) => _post(
        `api/admin/phone-verifications/${orgId}/reject/`, { reason },
    ),
};

// Wrappers that pass through ?organization= to the existing observe-only
// admin viewsets — used by Customer Detail's Subscriptions / Invoices tabs.
export const AdminAgentSubscriptions = {
    list: (params = {}) => _get('api/admin/agent-subscriptions/', { params }),
    get: (id) => _get(`api/admin/agent-subscriptions/${id}/`),
    cancel: (id, body = {}) => _post(`api/admin/agent-subscriptions/${id}/cancel/`, body),
};

export const AdminAgentInvoices = {
    list: (params = {}) => _get('api/admin/agent-invoices/', { params }),
    get: (id) => _get(`api/admin/agent-invoices/${id}/`),
    // Streams application/pdf — the caller opens it in an iframe or forces
    // download via <a download>.
    pdfUrl: (id) => `api/admin/agent-invoices/${id}/pdf/`,
};

export const SendBulkMakeCalls = (api_input) => {
    return _post('api/agents/call/initiate/', api_input);
}